import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";



type Props = {
  onActionEdit: (idGestaoRecebimentoEpi: number, openState: boolean) => void;
  onActionDelete: (idGestaoRecebimentoEpi: number, openState: boolean) => void;
};

export const GenerateGestaoRecebimentoEpiColumns = ({
  onActionEdit,
  onActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "idGestaoEpi",
      filterable: false,
      headerName: "Código",
      width: 70, 
      minWidth: 70,
      sortable: false,
      align: "center", 
      headerAlign: "center", 
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "nomeEpi",
      filterable: false,
      headerName: "Nome do EPI",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "especificacao",
      filterable: false,
      headerName: "Tipo/Numeração",
      width: 130, 
      minWidth: 130,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "ca",
      filterable: false,
      headerName: "Certificado de Aprovação (CA)",
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "marca",
      filterable: false,
      headerName: "Marca",
      minWidth: 180, 
      flex: 1, 
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "nomeCentroCusto",
      filterable: false,
      headerName: "Centro Custo",
      minWidth: 200,
      flex: 1, 
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade Recebida",
      minWidth: 110,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "quantidadeDisponivel",
      filterable: false,
      headerName: "Quantidade Disponivel",
      minWidth: 110,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "fornecedor",
      filterable: false,
      headerName: "Fornecedor",
      minWidth: 120,
      flex: 1, 
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "dataRecebimento",
      filterable: false,
      headerName: "Data de Recebimento",
      width: 90, 
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value && dayjs.utc(value).local().format('DD/MM/YYYY')}
          </div>
        );
      }
    },
    {
      field: "dataValidade",
      filterable: false,
      headerName: "Data de Validade",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value && dayjs.utc(value).local().format('DD/MM/YYYY')}
          </div>
        );
      }
    },
    {
      field: "notaFiscal",
      filterable: false,
      headerName: "Nº da nota fiscal",
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: 'acoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 90,
      resizable: false,
      valueGetter: (_, row) => ([row['idGestaoRecebimentoEpi']]),
      renderCell: ({ value: [idGestaoRecebimentoEpi] }) => {
        return (
          <div className="w-full h-full flex items-center justify-center gap-0">
            <IconButton
              onClick={e => onActionEdit(idGestaoRecebimentoEpi, true)}>
              <DynamicIcon
                nameIcon="EditRounded"
                size={20}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton
              onClick={() => onActionDelete(idGestaoRecebimentoEpi, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={20}
                className='text-red-500'
              />
            </IconButton>
          </div>
        );
      }
    }
  ];
}